import { render, staticRenderFns } from "./ComboAdditions.vue?vue&type=template&id=515b3f28&"
import script from "./ComboAdditions.vue?vue&type=script&lang=js&"
export * from "./ComboAdditions.vue?vue&type=script&lang=js&"
import style0 from "./ComboAdditions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports